import * as React from 'react';
import { cn } from '../../lib/utils';

const Label = React.forwardRef(({ className, ...props }, ref) => (
  <label
    ref={ref}
    className={cn('tw-text-sm tw-font-medium tw-leading-none tw-text-slate-700 dark:tw-text-slate-200', className)}
    {...props}
  />
));

Label.displayName = 'Label';

export { Label };
